import { useShallow } from "zustand/react/shallow";

import { Box } from "@atoms/box";
import { Modal } from "@atoms/modal";

import { closeModal, useModalStore } from "./store";

export function ModalContainer() {
  const isOpen = useModalStore(useShallow((state) => state.isOpen));
  const children = useModalStore(useShallow((state) => state.children));
  const options = useModalStore(useShallow((state) => state.options));

  return (
    <Modal open={isOpen} onClose={closeModal} {...options}>
      {options?.noBox ? (
        <>{children}</>
      ) : (
        <Box
          px={options?.noBoxPadding ? "0" : "8"}
          py={options?.noBoxPadding ? "0" : "8"}
          radius={"10"}
        >
          {children}
        </Box>
      )}
    </Modal>
  );
}
